// extracted by mini-css-extract-plugin
export default {"root":"defaultStyles-modules__root___hmGL","show-keyframe":"defaultStyles-modules__show-keyframe__hUxtl"};